export function sortArticles(articles) {
  return [...articles].sort((a, b) =>
    b.date.localeCompare(a.date) || b.published - a.published || a.id.localeCompare(b.id)
  );
}

export function articlesForTag(articles, tag) {
  return articles.filter(article => article.tags.some(value =>
    value.toLowerCase().includes(tag.toLowerCase())
  ));
}

export function articlesForPage(articles, page, pageSize) {
  return articles.slice((page - 1) * pageSize, page * pageSize);
}

async function loadArticles(location) {
  let url = new URL(location.href);
  url.searchParams.set('section_id', 'blog-display-date-feed');
  url.searchParams.set('page', '1');
  const visited = new Set();
  const articles = new Map();

  while (url) {
    if (visited.has(url.href)) throw new Error('Repeated blog feed page');
    visited.add(url.href);
    const response = await fetch(url, { signal: AbortSignal.timeout(30000) });
    if (!response.ok) throw new Error('Blog feed could not be loaded');
    const document = new DOMParser().parseFromString(await response.text(), 'text/html');
    const feed = document.querySelector('[data-blog-date-feed]');
    if (!feed) throw new Error('Blog feed is missing');
    feed.querySelectorAll('template[data-blog-date-card]').forEach(template => {
      const { id, date, published, tags, hasImage } = template.dataset;
      articles.set(id, {
        id, date, published: Number(published), tags: JSON.parse(tags),
        hasImage: hasImage === 'true', template
      });
    });
    const next = feed.dataset.next;
    url = next ? new URL(next, url) : null;
    if (url) {
      if (url.origin !== location.origin) throw new Error('Invalid blog feed origin');
      url.searchParams.set('section_id', 'blog-display-date-feed');
    }
  }
  return sortArticles([...articles.values()]);
}

function cardFor(article, tag) {
  const card = article.template.content.querySelector('.blog-grid-card').cloneNode(true);
  if (tag) {
    const label = card.querySelector('.article-tag');
    if (label) label.textContent = tag;
  }
  return card;
}

function updateListing(listing, articles) {
  const grid = listing.querySelector('[data-blog-date-grid]');
  if (grid) {
    const page = Math.max(1, Number(new URL(location.href).searchParams.get('page')) || 1);
    const cards = articlesForPage(articles, page, Number(listing.dataset.blogDatePageSize));
    grid.replaceChildren(...cards.map(article => {
      const item = document.createElement('div');
      item.className = 'masonry-item';
      item.append(cardFor(article));
      return item;
    }));
  }

  const carousel = listing.querySelector('[data-blog-date-carousel]');
  if (carousel) {
    const slides = articles.filter(article => article.hasImage).slice(0, 50).map(article => {
      const slide = document.createElement('div');
      slide.className = 'blog-carousel-grid';
      slide.append(cardFor(article));
      return slide;
    });
    const initialized = carousel.classList.contains('slick-initialized');
    const $carousel = window.jQuery ? window.jQuery(carousel) : null;
    const options = initialized ? { ...$carousel.slick('getSlick').options, initialSlide: 0 } : null;
    if (initialized) $carousel.slick('unslick');
    carousel.replaceChildren(...slides);
    if (initialized) $carousel.slick(options);
  }
}

function updateCategories(articles) {
  document.querySelectorAll('[data-blog-date-category]').forEach(category => {
    const tag = category.dataset.blogDateCategory;
    const matching = articlesForTag(articles, tag);
    category.querySelectorAll('.blog-grid, [class^="blog-grid-layout-"]').forEach(layout => {
      layout.querySelectorAll('.blog-grid-card').forEach((card, index) => {
        if (matching[index]) card.replaceWith(cardFor(matching[index], tag));
      });
    });
  });
}

async function initialize() {
  const listings = document.querySelectorAll('[data-blog-date-listing]');
  if (!listings.length) return;
  try {
    const articles = await loadArticles(window.location);
    listings.forEach(listing => updateListing(listing, articles));
    updateCategories(articles);
  } catch (error) {
    console.warn('Blog display-date ordering unavailable; keeping published order.', error);
  }
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
}
